var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewAdults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 23,
    fill: "white",
    stroke: "#DDDDDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6845 18.7368C28.6845 21.3529 26.5637 23.4736 23.9477 23.4736C21.3318 23.4736 19.2109 21.3529 19.2109 18.7368C19.2109 16.1208 21.3318 14 23.9477 14C26.5637 14 28.6845 16.1208 28.6845 18.7368Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8942 33.4745C32.8942 28.536 28.8854 24.5273 23.9471 24.5273C19.0088 24.5273 15 28.5362 15 33.4745C15 33.765 15.2358 34.0008 15.5262 34.0008H32.3684C32.6588 34.0008 32.8946 33.765 32.8946 33.4745H32.8942Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewAdults);
export default __webpack_public_path__ + "static/media/newAdults.7c08b6f17f66d893741ccffeb44474e2.svg";
export { ForwardRef as ReactComponent };